module.exports = __webpack_public_path__ + "fonts/mem6YaGs126MiZpBA-UFUK0Zdc0.b61a9055.woff2";